import React, { useState } from 'react';
import { compose, mapProps } from 'recompose';
import { reduxForm } from 'redux-form/immutable';
import { useHistory } from 'react-router-dom';
import withMe from '../../containers/withMe';
import requireProps from '../../../app/lib/requireProps';
import { useTranslation } from 'react-i18next';
import PlacesFormConsultant from '../../../app/Resources/View/components/PlacesFormConsultant';
import { Endpoints } from '../../../app/lib/LeanLinkService';
import Routes from '../../../public/Router/Routes';

import API from '../../../app/lib/APIHelpers/API';
import Notification from '../../../app/components/Notifications/Notification';
import { NotificationTypes } from '../../../app/components/Notifications/constants';
import './style.scss'

function Areas({resource}) {
  const { t } = useTranslation();
  const [forceCloseEditMode, setForceCloseEditMode] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [isErrorNotification, setIsErrorNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const history = useHistory();

  const updateAreas = async (selectedAreas) => {
    let areasForAPI = [];
    setIsLoading(true)
    selectedAreas.map((item)=>{
        if(!item.geoCode){
            delete item.geoCode;
            delete item.id;
            delete item.type;
            areasForAPI.push(item)
        }
        else{
            areasForAPI.push({geoCode: item.geoCode})
        }
    })
    API.patch(Endpoints.consultantAreas(), { areas: areasForAPI })
        .then(function (response) {
            if (response && response[0]) {
                setForceCloseEditMode(true)
                setNotificationMessage(t('Intresseområde uppdaterad'))
                setShowNotification(true)
                setIsErrorNotification(false)
                setTimeout(function () {
                    setShowNotification(false)
                    history.push(Routes.home());
                }, 2000)
            }
        })
        .catch(function (errors) {
            setNotificationMessage(t('Ett fel har inträffat. Vänligen försök igen senare'))
            setShowNotification(true)
            setIsErrorNotification(true)
            setTimeout(function () {
                setShowNotification(false)
            }, 3000)
        });
};

  return (
    <div className="row">
        {showNotification &&
            <div className="notificationWrapper">
                <Notification
                    icon={isErrorNotification ? "fa-ban" : "fa-check"}
                    message={notificationMessage}
                    type={isErrorNotification ? NotificationTypes.ERROR : NotificationTypes.SUCCESS}
                />
            </div>
        }
        {resource && resource.id &&
            <div className="col-md-4 col-md-offset-4">
                <span className="infoText">{t("Nedan kan du ange ett eller flera områden där du vill arbeta. Områden kan anges som")}</span>
                <span className="infoText listDecoration">{t("plats kombinerat med antal kilometer från denna plats")}</span>
                <span className="infoText listDecoration">{t("svenska län")}</span>
                <PlacesFormConsultant
                    id={resource.id} 
                    currentUserId={resource.id} 
                    isConsultantPortal={true}
                    isEditable={true} 
                    handleSubmit={(selectedAreas)=>{
                        updateAreas(selectedAreas)
                    }}
                    forceCloseEditMode={forceCloseEditMode}
                    setForceCloseEditMode={setForceCloseEditMode}
                    actionInProgress={isLoading}
                />
            </div>
        }
        </div>
  );
}
const withReduxForm = reduxForm({
    form: 'CONSULTANT_AREA_FORM',
    enableReinitialize: true,
  });
export default compose(
    withMe,
    requireProps(['resource'], true, true),
    mapProps(({ resource }) => ({
        resource: (resource && resource.toJS)? resource.toJS() : null,
    })),
    withReduxForm
)(Areas);
